module.exports = __webpack_public_path__ + "img/tablet-elbow-4_54x72.998035cf.png";